import { ITimestampJSON } from './TransportPlanTimestamp'

// events constants
export enum EventCode {
  CRD = 'crd',
  CEP = 'cep', // fcl
  CAS = 'cas', // fcl
  CDS = 'cds', // fcl
  VGM = 'vgm', // fcl
  CSO = 'cso', // fcl
  SPS = 'sps', // lcl
  CGI = 'cgi', // fcl
  CLL = 'cll',
  DPR = 'dpr',
  VDL = 'vdl',
  VAT1 = 'vat1',
  VDT1 = 'vdt1',
  VAT2 = 'vat2',
  VDT2 = 'vdt2',
  VAT3 = 'vat3',
  VDT3 = 'vdt3',
  VAT4 = 'vat4',
  VDT4 = 'vdt4',
  VAD = 'vad',
  CDD = 'cdd',
  CGO = 'cgo', // fcl
  AOA = 'aoa', // air
  ADO = 'ado', // air
  AAD = 'aad', // air
  RCF = 'rcf', // air
  DLV = 'dlv', // air
  SDC = 'sdc', // lcl
  CSD = 'csd', // fcl
  CDC = 'cdc', // fcl
  CED = 'ced', // fcl
  CER = 'cer', // fcl

  CGIMO = 'cgimo',
  CGOMO = 'cgomo',
  CGIMD = 'cgimd',
  CGOMD = 'cgomd',

  VDD = 'vessel-departure-at-destination',

  // Rail
  RAIL_PICKUP = 'pickup',
  RAIL_DEPARTURE = 'train-departure',
  RAIL_ARRIVAL = 'train-arrival',
  RAIL_DELIVERY = 'delivery',
  RAIL_CARGO_READY = 'cargo-ready',

  // AIRPORT
  AIRPORT_ARIVAL_1 = 'transit-airport-arrival-1',
  AIRPORT_ARIVAL_2 = 'transit-airport-arrival-2',
  AIRPORT_ARIVAL_3 = 'transit-airport-arrival-3',
  AIRPORT_ARIVAL_4 = 'transit-airport-arrival-4',
  AIRPORT_DEPARTURE_1 = 'transit-airport-departure-1',
  AIRPORT_DEPARTURE_2 = 'transit-airport-departure-2',
  AIRPORT_DEPARTURE_3 = 'transit-airport-departure-3',
  AIRPORT_DEPARTURE_4 = 'transit-airport-departure-4',
}

export interface IShipTpEvent {
  actual?: boolean
  aggregatedTimestamp?: ITimestampJSON
  revisedTimestamp?: ITimestampJSON
  initialTimestamp?: ITimestampJSON
}
